import { render, staticRenderFns } from "./show-detail.vue?vue&type=template&id=42e37ad5&scoped=true&lang=html&"
import script from "./show-detail.vue?vue&type=script&lang=js&"
export * from "./show-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e37ad5",
  null
  
)

export default component.exports